export enum SendFormsOrigin {
  FORMS,
  CONTACTS,
  COMPLETE,
  KIOSK,
  MESSAGING,
  NONE,
}

export enum SendFormStep {
  SELECT_CONTACT,
  SELECT_APPOINTMENT,
  SELECT_DELIVERY_METHOD,
  SELECT_DOCUMENT,
  SELECTED_MESSAGE_MODE,
  SELECT_LOCATION,
}

export type DeliveryMethod = 'email' | 'message' | 'kiosk';
export enum ContactNumberType {
  HOME,
  MOBILE,
  WORK,
}

/**
 * Configuration for which steps to show in the send forms flow
 */
export type SendFormsStepsConfig = {
  selectDocument?: boolean;
  addDetails?: boolean;
  reviewSend?: boolean;
};

/**
 * Mode for the send forms flow
 * - standalone: Full modal experience (default for contact profile)
 * - embedded: Embedded in another flow (e.g., messaging templates)
 */
export type SendFormsMode = 'standalone' | 'embedded';

/**
 * Callback data when form link is generated in embedded mode
 */
export type FormLinkGeneratedData = {
  formLink: string;
  submissionId: string;
  appointmentId?: string;
  appointmentAt?: string;
  officeNote?: {
    label: string;
    value: string;
  };
  attachments?: Array<{
    id: string;
    name: string;
    url: string;
  }>;
};
